<div class="p-2">
  <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Generator użytkowników</div>

  <!-- Górny pas: generator 40% / wyszukiwarka 60%. Poniżej breakpointu lg oba bloki idą w wiersze na 100% szerokości. -->
  <div class="top-panels flex flex-column lg:flex-row gap-3 mb-4 align-items-stretch">
    <div class="generator-panel">
      <div class="main-card p-3 h-full">
        <form [formGroup]="generatorForm" class="w-full flex flex-column gap-2 align-items-start justify-content-start">
          <div class="w-full flex flex-column">
            <label class="text-sm text-color-secondary mb-2">Liczba kont do wygenerowania</label>
            <p-inputNumber
              formControlName="requestedUsersCount"
              styleClass="w-full"
              placeholder="Wpisz liczbę użytkowników"
              [min]="1"
            ></p-inputNumber>
          </div>

          <div class="flex flex-column">
            <p-checkbox
              formControlName="noTimeLimit"
              [binary]="true"
              label="Konta bez limitu czasowego"
              inputId="noTimeLimit"
            ></p-checkbox>
          </div>

          <div class="w-full flex flex-column sm:flex-row gap-3" *ngIf="!generatorForm.value.noTimeLimit">
            <div class="flex-1 flex flex-column">
              <label class="text-sm text-color-secondary mb-2">Ważność konta (dni)</label>
              <p-inputNumber
                formControlName="validDays"
                styleClass="w-full"
                placeholder="Wpisz liczbę dni"
                [min]="1"
              ></p-inputNumber>
            </div>
            <div class="flex-1 flex flex-column">
              <label class="text-sm text-color-secondary mb-2">Ważny do</label>
              <p-calendar
                formControlName="validUntil"
                dateFormat="dd.mm.yy"
                [showIcon]="true"
                [minDate]="minValidUntil"
                placeholder="Wybierz datę"
                styleClass="w-full"
                appendTo="body"
              ></p-calendar>
            </div>
          </div>

          <div class="w-full flex flex-column">
            <label class="text-sm text-color-secondary mb-2">Przypisz do OSK (opcjonalnie)</label>
            <p-autoComplete
              formControlName="oskSearch"
              [suggestions]="filteredOsks"
              optionLabel="oskName"
              field="oskName"
              placeholder="Wyszukaj OSK"
              styleClass="w-full"
              [showEmptyMessage]="false"
              (onSelect)="onOskSelect($event)"
              (onClear)="clearOsk()"
            ></p-autoComplete>
            <small *ngIf="selectedOsk" class="text-color-secondary mt-1">
              Wybrano: {{ selectedOsk.oskName }}
              <a class="cursor-pointer underline" (click)="clearOsk()">(wyczyść)</a>
            </small>
          </div>

          <div class="w-full flex justify-content-end">
            <p-button label="Generuj" [loading]="loading" (onClick)="generate()" data-clarity-unmask="true"></p-button>
          </div>
        </form>
      </div>
    </div>

    <div class="search-panel">
      <div class="main-card p-3 h-full">
        <div class="font-semibold text-xl mb-3">Wyszukiwarka kodów QR</div>
        <app-book-access-ticket-search></app-book-access-ticket-search>
      </div>
    </div>
  </div>

  <div class="main-card p-3">
    <div class="font-semibold text-xl mb-3">Historia</div>

    <fas-service-dynamic-table
      [columns]="historyColumns"
      [dataMode]="'server'"
      [dataService]="fetchHistory"
      (dataLoaded)="handleHistoryLoaded($event)"
      [resetTrigger]="resetTrigger.asObservable()"
      [columnTemplates]="{
        dateTemplate: dateTemplateRef,
        validDaysTemplate: validDaysTemplateRef,
        oskNameTemplate: oskNameTemplateRef,
        printedTemplate: printedTemplateRef,
        printedDateTemplate: printedDateTemplateRef
      }"
    >
      <ng-template #dateTemplateRef let-row>{{ row.created | date: 'dd.MM.yyyy' }}</ng-template>
      <ng-template #validDaysTemplateRef let-row>{{ row.validDays ? row.validDays + ' dni' : 'Bez limitu' }}</ng-template>
      <ng-template #oskNameTemplateRef let-row>{{ row.oskName || '—' }}</ng-template>
      <ng-template #printedTemplateRef let-row>
        <p-checkbox [ngModel]="row.printed" [binary]="true" [disabled]="true"></p-checkbox>
      </ng-template>
      <ng-template #printedDateTemplateRef let-row>{{ row.printedDate ? (row.printedDate | date: 'dd.MM.yyyy HH:mm') : '' }}</ng-template>
    </fas-service-dynamic-table>

    <app-book-access-package-details
      [data]="historyItem"
      [dataList]="historyList"
      [dataIndex]="historyIndex"
      [ID_dialog]="ID_PACKAGE_DETAILS"
      (changed)="onPackageDetailsChanged()"
    ></app-book-access-package-details>
  </div>
</div>
